export const enrichCompareProductData = (
  compareProductData = [],
  productData = []
) =>
  // Enrich compareProduct array data by adding extra product attributes to each product
  // from the product API, to allow decisions to be made about product on compare modal
  // e.g. should Add to Basket button be shown
  compareProductData.map((compareProduct) => {
    const { productId } = compareProduct;
    const matchedProduct =
      productData.find((product) => product.id === productId) || {};

    const {
      isInStoreOnly,
      isFutureRelease,
      isMultiSku,
      defaultSkuId,
      defaultVariantId,
      colorSwatches,
      rating,
      price,
    } = matchedProduct;
    return {
      ...compareProduct,
      isInStoreOnly,
      isFutureRelease,
      isMultiSku,
      defaultSkuId,
      defaultVariantId,
      colorSwatches,
      rating,
      priceRange: price,
    };
  });
